import React, { useCallback, useState, createContext, useContext } from 'react';
import { translations, TranslationKey, Language } from '../i18n/translations';
const COVER_IMAGES = {
  es: 'https://cdn.magicpatterns.com/uploads/tMPwTWnudTgzcXXb9s6Bxw/Screenshot_2026-02-19_at_12.48.38_PM.png',
  en: 'https://cdn.magicpatterns.com/uploads/e57Gjf4bffdwySWShRmZo9/Screenshot_2026-03-05_at_8.38.40_PM.png'
};
const AUDIO_URLS = {
  es: 'https://github.com/jvzng/webpage_chatbot_closer/raw/980fc46fbc1f0174fb4817a62896dc782237fcd9/ElevenLabs_2026-02-19T20_15_33_Declan%20Sage%20-%20Wise%2C%20Deliberate%2C%20Captivating_pvc_sp76_s50_sb50_se48_b_m2.mp3',
  en: 'https://github.com/jvzng/webpage_chatbot_closer/raw/6701578e8314131618231fb00a2c739ca6629c0d/DMT%20intro%20audio%20EN.mp3'
};
const CHECKOUT_URLS = {
  es: 'https://pay.hotmart.com/J104538438A?checkoutMode=10',
  en: 'https://pay.hotmart.com/K104779298D?checkoutMode=10'
};
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: TranslationKey) => string;
  coverImage: string;
  audioUrl: string;
  checkoutUrl: string;
  showSplash: boolean;
  selectLanguage: (lang: Language) => void;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
interface LanguageProviderProps {
  children: ReactNode;
}
export function LanguageProvider({
  children
}: LanguageProviderProps) {
  const [lang, setLang] = useState<Language>('en');
  const [showSplash, setShowSplash] = useState(true);
  const t = useCallback((key: TranslationKey): string => {
    return translations[lang][key] || key;
  }, [lang]);
  const coverImage = COVER_IMAGES[lang];
  const audioUrl = AUDIO_URLS[lang];
  const checkoutUrl = CHECKOUT_URLS[lang];
  const selectLanguage = useCallback((selectedLang: Language) => {
    setLang(selectedLang);
    setShowSplash(false);
  }, []);
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t,
    coverImage,
    audioUrl,
    checkoutUrl,
    showSplash,
    selectLanguage
  }} data-id="element-413">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}